module.exports = __webpack_public_path__ + "img/2f_r_fukumitsu@2x.b000b7dd.png";